module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "avg-consumption",
    attrs: {
      "id": "avg-consumption"
    }
  }, [_c('div', {
    staticClass: "body"
  }, [_c('highcharts', {
    attrs: {
      "options": _vm.options
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-146a89bb","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/AvgConsumption.vue
// module id = 938
// module chunks = 27